module.exports = __webpack_public_path__ + "img/a10.de4116ff.png";